/**
 * Representa os dados extraídos de um token JWT de autenticação
 */
export class ParsedToken {
  /** Data de expiração do token (timestamp Unix) */
  readonly exp: number;

  /** Data de emissão do token (timestamp Unix) */
  readonly iat: number;

  /** Último momento em que a autenticação foi realizada (timestamp Unix) */
  readonly auth_time: number;

  /** ID único do token (JWT ID) */
  readonly jti: string;

  /** URL do emissor do token (servidor de autenticação) */
  readonly iss: string;

  /** Destinatários para os quais o token foi emitido */
  readonly aud: string[];

  /** ID do usuário (subject) */
  readonly sub: string;

  /** Tipo do token */
  readonly typ: string;

  /** Cliente autorizado que solicitou o token */
  readonly azp: string;

  /** ID da sessão */
  readonly sid: string;

  /** Nível de contexto de autenticação */
  readonly acr: string;

  /** Origens permitidas para uso do token (CORS) */
  readonly allowedOrigins: string[];

  /** Escopos de acesso concedidos */
  readonly scope: string;

  /** Indica se o email do usuário foi verificado */
  readonly emailVerified: boolean;

  /** Data de criação do usuário (timestamp Unix em milissegundos) */
  readonly createdDate: string;

  /** Funções/permissões atribuídas ao usuário */
  readonly roles: string[];

  /** Nome completo do usuário */
  readonly name: string;

  /** IDs de inquilinos/organizações aos quais o usuário tem acesso */
  readonly tenantId: string[];

  /** Grupos aos quais o usuário pertence */
  readonly groups: string[];

  /** Nome de usuário preferido (geralmente CPF ou outro identificador único) */
  readonly preferredUsername: string;

  /** Primeiro nome do usuário */
  readonly givenName: string;

  /** Sobrenome do usuário */
  readonly familyName: string;

  /** Email do usuário */
  readonly email: string;

  constructor(tokenData: any) {
    this.exp = tokenData.exp;
    this.iat = tokenData.iat;
    this.auth_time = tokenData.auth_time;
    this.jti = tokenData.jti;
    this.iss = tokenData.iss;
    this.aud = tokenData.aud;
    this.sub = tokenData.sub;
    this.typ = tokenData.typ;
    this.azp = tokenData.azp;
    this.sid = tokenData.sid;
    this.acr = tokenData.acr;
    this.allowedOrigins = tokenData['allowed-origins'];
    this.scope = tokenData.scope;
    this.emailVerified = tokenData.email_verified;
    this.createdDate = tokenData.createdDate;
    this.roles = tokenData.roles;
    this.name = tokenData.name;
    this.tenantId = tokenData.tenantId;
    this.groups = tokenData.groups;
    this.preferredUsername = tokenData.preferred_username;
    this.givenName = tokenData.given_name;
    this.familyName = tokenData.family_name;
    this.email = tokenData.email;
  }
}
